import React from 'react';
import { Stack, Grid, InputAdornment, IconButton, MenuItem, Box, FormControl, Divider } from '@mui/material';
import { StyledCard, StyledCardTitle, CustomInputLabel, CustomDatePicker, CustomSelect, CustomSearch, SelectInputProps, InputProps, FlexDiv, } from '../../../../../custom/components';
import styles from '../../../../../custom/style.module.css';
import fltStyles from './flightmanifest.module.css';
import { AttachFile as AttachFileIcon, Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import moment from 'moment';
import { DateFormat } from 'custom/constants';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';

const FlightManifest = (props) => {

  const columns = [
    {
      accessorKey: 'flight_no',
      header: 'Flight No.',
      size: 80,
      cell: info => {
        const row = info.row.original;
        return row?.airline?.code + row?.flight_no;
      },
    },
    {
      accessorKey: 'flight_date',
      header: 'Flight Date',
      size: 100,
      cell: info => {
        const row = info.row.original;
        return moment(row?.flight_date).format(DateFormat)?.toUpperCase();
      },
    },
    {
      id: 'action',
      header: <div className={`${styles.textCenter}`}>Action</div>,
      size: 100,
      enableSorting: false,
      enableColumnFilter: false,
      cell: info => {
        const row = info.row.original;
        return (
          <Stack
            direction='row'
            spacing={2}
            justifyContent='center'
            className={styles.actionIcons}
          >
            <div onClick={() => props.handlePopover('attached_docs', true, row)}>
              <AttachFileIcon
                fontSize='small'
                className={`${styles.pointer}`}
              />
            </div>
          </Stack>
        );
      },
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <StyledCard>
          <FlexDiv className={styles.pb0}><StyledCardTitle>Filter Flight List</StyledCardTitle></FlexDiv>
          <Grid container spacing={2} columnSpacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <CustomInputLabel className={styles.colorTransparent}>-</CustomInputLabel>
              <CustomSearch
                id='search'
                type='search'
                fullWidth
                placeholder='Enter Flight Number'
                name='awb'
                className={`${styles.brInput}`}
                value={props.searchOptions.search}
                onChange={(e) => props.handleChange(e, 'search')}
                InputProps={{
                  classes: { input: styles.pr0 },
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      onClick={props.search}
                    >
                      <Search fontSize='inherit' />
                    </IconButton>
                  </InputAdornment>,
                }}
                onKeyDown={
                  (e) => {
                    if (e.key === 'Enter') {
                      props.search(true);
                    }
                  }
                }
              />
            </Grid>
            <Grid item sm='auto'> 
              <Divider orientation='vertical' variant='middle' flexItem sx={{
                backgroundColor: '#ffffff8f',
                height: '30px', 
                marginTop: '18px',
                '@media (max-width: 900px)': { display: 'none', }
              }} />            
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomInputLabel htmlFor='' aria-label='Enter from date'>From</CustomInputLabel>
              <CustomDatePicker
                slotProps={{
                  textField: {
                    ...InputProps,
                    placeholder: 'From Date',
                    fullWidth: true
                  },
                }}
                className={styles.w100}
                format='DD MMM YYYY'
                name='from'
                value={dayjs(props.searchOptions.from)}
                // helperText={}
                onChange={(e) => props.handleChange(e, 'from')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomInputLabel htmlFor='' aria-label='Enter to date'>To</CustomInputLabel>
              <CustomDatePicker
                slotProps={{
                  textField: {
                    ...InputProps,
                    placeholder: 'To Date',
                    fullWidth: true
                  },
                }}
                className={styles.w100}
                format='DD MMM YYYY'
                name='to'
                value={dayjs(props.searchOptions.to)}
                // helperText={}
                onChange={(e) => props.handleChange(e, 'to')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <CustomInputLabel className={styles.colorTransparent}>-</CustomInputLabel>
              <IconButton disableRipple onClick={() => props.search()} className={styles.p0}>
                <Search fontSize='1.7rem' classes={{ root: `${styles.sqIcons} ${styles.mb0}` }} />
              </IconButton>
            </Grid>
          </Grid>
        </StyledCard>
      </Grid>

      <Grid item xs={12}>
        <StyledCard className={styles.positionRelative}>
          {/* <CustomSearch
              id='search'
              name='awb'
              value={props.searchOptions.awb}
              variant='outlined'
              size='small'
              placeholder='Enter Flight Number'
              onChange={props.onChangefilter}
              type='search'
              className={styles.brInput}
              InputProps={{
                endAdornment: <InputAdornment position='end'>
                  <IconButton
                    size='small'
                    aria-label='search'
                    edge='end'
                    onClick={() => props.onChangefilter({
                      target: {
                        name: 'awb_search',
                        value: ''
                      }
                    })}
                  >
                    <Search fontSize='inherit' />
                  </IconButton>
                </InputAdornment>,
              }}
              InputLabelProps={{ shrink: false }}
            /> */}
          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} sm='auto'>
              <FlexDiv><StyledCardTitle>Flights</StyledCardTitle></FlexDiv>
            </Grid>
            <Grid item xs={6} md></Grid>
            <Grid item xs={12} sm={6} md={2} lg={1} minWidth={160} display='flex' flexDirection='row' alignItems='center'>
              <CustomInputLabel id='airline-label' aria-label='Select airline' className={`${styles.ipLabel}`}>Airline</CustomInputLabel>
              <FormControl fullWidth>
                <CustomSelect
                  {...SelectInputProps}
                  fullWidth
                  id='airline'
                  labelId='airline-label'
                  name='airline'
                  value={props.filter.airline}
                  onChange={props.onChangefilter}
                >
                  <MenuItem value=''>All</MenuItem>
                  {props.airline && props.airline.map(a => {
                    return (<MenuItem key={a} value={a} >{a}</MenuItem>);
                  })}
                </CustomSelect>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={1} minWidth={250} display='flex' flexDirection='row' alignItems='center'>
              <CustomInputLabel id='flight-no-label' aria-label='Enter flight number' className={`${styles.ipLabel}`}>Flight#</CustomInputLabel>
              <FormControl fullWidth>
                <CustomSelect
                  {...SelectInputProps}
                  fullWidth
                  id='flight'
                  labelId='flight-no-label'
                  name='flight'
                  value={props.filter.flight}
                  onChange={props.onChangefilter}
                >
                  <MenuItem value=''>All</MenuItem>
                  {props.flight && props.flight.map(f => {
                    if (!props.filter.airline || f.substring(0, 2) === props.filter.airline)
                      return (<MenuItem key={f} value={f}>{f}</MenuItem>);
                  })}
                </CustomSelect>
              </FormControl>
            </Grid>
          </Grid>

          <div className={styles.tableWrapper}>
            <Box className={`${styles.tableOuter} ${fltStyles.fltTableOuter}`}>
              <TableWrapper columns={columns} data={props.data} />
            </Box>
          </div>
        </StyledCard>
      </Grid>

    </Grid>
  );
};

export default FlightManifest;
